import { useEffect, useState, useContext } from 'react';
import { db } from '../../firebaseConfig';
import { collection, doc, setDoc } from 'firebase/firestore';
import { useUser } from '../../contexts/UserContext';

const MetaAuthCallback = () => {
  const [pages, setPages] = useState([]);
  const [error, setError] = useState(null);
  const { currentUser } = useUser();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");

    if (code && currentUser?.coffeeShopId) {
      fetch('http://localhost:5001/loyalitysystem-d564d/us-central1/exchangeMetaCode', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ code })
      })
        .then(res => res.json())
        .then(async (data) => {
          console.log("✅ Access Token:", data.accessToken);
          if (!data.accessToken) {
            setError("Access token not returned. Please check server logs.");
            return;
          }

          const res = await fetch(`https://graph.facebook.com/v19.0/me/accounts?access_token=${data.accessToken}`);
          const result = await res.json();

          if (result.error) {
            console.error("❌ Error fetching pages:", result.error);
            setError(result.error.message);
            return;
          }

          const pagesWithTokens = result.data || [];
          setPages(pagesWithTokens);

          for (const page of pagesWithTokens) {
            await setDoc(doc(db, "meta_pages", page.id), {
              coffeeShopId: currentUser.coffeeShopId,
              name: page.name,
              pageId: page.id,
              pageAccessToken: page.access_token,
              category: page.category,
              tasks: page.tasks || [],
              connectedAt: new Date().toISOString(),
              instagram_connected: false // to be updated if IG exists
            });

            // Try to fetch linked Instagram account
            try {
              const igRes = await fetch(`https://graph.facebook.com/v19.0/${page.id}?fields=connected_instagram_account&access_token=${page.access_token}`);
              const igData = await igRes.json();

              if (igData.connected_instagram_account?.id) {
                await setDoc(doc(db, "meta_pages", page.id), {
                  instagram_connected: true,
                  instagram_id: igData.connected_instagram_account.id
                }, { merge: true });
              }
            } catch (err) {
              console.warn("Instagram fetch error for page", page.id);
            }
          }
        })
        .catch(err => {
          console.error("❌ Token exchange error:", err);
          setError("Failed to connect to Meta. Please try again.");
        });
    }
  }, [currentUser]);

  return (
    <div style={{ padding: "2rem" }}>
      <h2>Meta Connection Status</h2>

      {error && <p style={{ color: "red" }}>❌ {error}</p>}

      {pages.length > 0 ? (
        <>
          <h3>✅ Connected Pages:</h3>
          <ul>
            {pages.map((page) => (
              <li key={page.id} style={{ marginBottom: "1rem" }}>
                <strong>{page.name}</strong> (ID: {page.id})<br />
                <small>Page Access Token:</small><br />
                <code style={{ wordBreak: "break-all" }}>{page.access_token}</code>
              </li>
            ))}
          </ul>
        </>
      ) : (
        !error && <p>Connecting to Meta, please wait...</p>
      )}
    </div>
  );
};

export default MetaAuthCallback;
